<template>
    <div>
        <div class="card">
            <div class="card-header">
                <h5 class="header-case mb-0">Conversations</h5>
            </div>
            <div class="card-body">
                <!-- <div class="row">
                    <div class="col-md-3 border-right">
                        <div v-if="conversations">
                            <div v-for="conversation in conversations" :key="conversation.id" @click="selectConversation(conversation)">
                                <strong>{{ conversation.user.displayName }}</strong>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div v-if="!conversation">
                            <p class="thin-title">
                                Please select a conversation to get started
                            </p>
                        </div>
                        <div v-else>
                            <div v-for="event in renderableEvents" :key="event.id">
                                <message-element :event="event" />
                            </div>
                            <send-message :conversation="selectedConversation" :activeEvent="activeEvent" />
                        </div>
                    </div>
                </div> -->
                <div class="row clearfix">
                    <div class="col-lg-12">
                        <div class="card chat-app">
                            <div id="plist" class="people-list">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"
                                            ><i class="fa fa-search"></i
                                        ></span>
                                    </div>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Search..."
                                    />
                                </div>
                                <ul class="list-unstyled chat-list mt-2 mb-0">
                                    <li
                                        class="clearfix"
                                        v-for="conversation in conversations"
                                        :key="conversation.id"
                                        @click="
                                            selectConversation(conversation)
                                        "
                                        :class="{
                                            active:
                                                selectedConversation &&
                                                selectedConversation.id ==
                                                    conversation.id
                                        }"
                                    >
                                        <img
                                            src="https://bootdey.com/img/Content/avatar/avatar1.png"
                                            alt="avatar"
                                        />
                                        <div class="about">
                                            <div class="name">
                                                {{
                                                    conversation.user
                                                        .displayName
                                                }}
                                            </div>
                                            <!-- <div class="status">
                                                <i
                                                    class="fa fa-circle offline"
                                                ></i>
                                                left 7 mins ago
                                            </div> -->
                                        </div>
                                    </li>
                                    <!-- 
                                    <li class="clearfix">
                                        <img
                                            src="https://bootdey.com/img/Content/avatar/avatar3.png"
                                            alt="avatar"
                                        />
                                        <div class="about">
                                            <div class="name">Mike Thomas</div>
                                            <div class="status">
                                                <i
                                                    class="fa fa-circle online"
                                                ></i>
                                                online
                                            </div>
                                        </div>
                                    </li>
                                    <li class="clearfix">
                                        <img
                                            src="https://bootdey.com/img/Content/avatar/avatar7.png"
                                            alt="avatar"
                                        />
                                        <div class="about">
                                            <div class="name">
                                                Christian Kelly
                                            </div>
                                            <div class="status">
                                                <i
                                                    class="fa fa-circle offline"
                                                ></i>
                                                left 10 hours ago
                                            </div>
                                        </div>
                                    </li>
                                    <li class="clearfix">
                                        <img
                                            src="https://bootdey.com/img/Content/avatar/avatar8.png"
                                            alt="avatar"
                                        />
                                        <div class="about">
                                            <div class="name">Monica Ward</div>
                                            <div class="status">
                                                <i
                                                    class="fa fa-circle online"
                                                ></i>
                                                online
                                            </div>
                                        </div>
                                    </li>
                                    <li class="clearfix">
                                        <img
                                            src="https://bootdey.com/img/Content/avatar/avatar3.png"
                                            alt="avatar"
                                        />
                                        <div class="about">
                                            <div class="name">Dean Henry</div>
                                            <div class="status">
                                                <i
                                                    class="fa fa-circle offline"
                                                ></i>
                                                offline since Oct 28
                                            </div>
                                        </div>
                                    </li> -->
                                </ul>
                            </div>
                            <div class="chat">
                                <div v-if="selectedConversation == null">
                                    Please select a conversation to get started.
                                </div>
                                <div v-else>
                                    <div class="chat-header clearfix">
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <a
                                                    href="javascript:void(0);"
                                                    data-toggle="modal"
                                                    data-target="#view_info"
                                                >
                                                    <img
                                                        src="https://bootdey.com/img/Content/avatar/avatar2.png"
                                                        alt="avatar"
                                                    />
                                                </a>
                                                <div class="chat-about">
                                                    <h6 class="m-b-0">
                                                        {{
                                                            selectedConversation
                                                                .user
                                                                .displayName
                                                        }}
                                                    </h6>
                                                    <!-- <small
                                                        >Last seen: 2 hours
                                                        ago</small
                                                    > -->
                                                </div>
                                            </div>
                                            <div
                                                class="col-lg-6 hidden-sm text-right"
                                            >
                                                <a
                                                    href="javascript:void(0);"
                                                    class="btn btn-outline-secondary"
                                                    ><i class="fa fa-camera"></i
                                                ></a>
                                                <a
                                                    href="javascript:void(0);"
                                                    class="btn btn-outline-primary"
                                                    ><i class="fa fa-image"></i
                                                ></a>
                                                <a
                                                    href="javascript:void(0);"
                                                    class="btn btn-outline-info"
                                                    ><i class="fa fa-cogs"></i
                                                ></a>
                                                <a
                                                    href="javascript:void(0);"
                                                    class="btn btn-outline-warning"
                                                    ><i
                                                        class="fa fa-question"
                                                    ></i
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="chat-history" id="chat-history">
                                        <ul class="m-b-0">
                                            <message-element
                                                :key="event.id"
                                                v-for="event in renderableEvents"
                                                :event="event"
                                            />
                                        </ul>
                                    </div>
                                    <div class="chat-message clearfix">
                                        <send-message
                                            :conversation="selectedConversation"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MessagingService from "../../services/messaging-service";
import SendMessage from "./SendMessage";
import MessageElement from "./MessageElement";
export default {
    components: {
        SendMessage,
        MessageElement
    },
    computed: {
        renderableEvents() {
            return this.events.filter(event => {
                // @todo: return recent typing events
                return event.type == "message";
            });
        }
    },
    data() {
        return {
            selectedConversation: null,
            conversations: null,
            events: [],
            activeEvent: null
        };
    },
    mounted() {
        this.getConversations();
        var pusher = new Pusher("ae1bec78142fb322fc8e", {
            cluster: "eu"
        });

        var app = this;
        var channel = pusher.subscribe("events");
        channel.bind("messaging-event", function(data) {
            app.processNewEvent(data);
        });
    },
    methods: {
        async getConversations() {
            this.conversations = await MessagingService.conversations.index(
                Spark.state.currentTeam.id
            );
        },
        selectConversation(conversation) {
            this.selectedConversation = conversation;
            this.getEvents();
        },
        processNewEvent(data) {
            console.log(JSON.stringify(data));
            // if active conversation -> push event
            // if not active conversation -> show unread message count
            if (
                data.conversationId &&
                this.selectedConversation &&
                data.conversationId == this.selectedConversation.id
            ) {
                this.events.push(data);
                // @todo: If the user is scrolled all the way down
                // before the new Event, then the scroll should be
                // adjusted. Otherwise, we should leave them where
                // they were before
                this.$nextTick(function() {
                    this.adjustScroll();
                });
            }
        },
        adjustScroll() {
            var element = document.getElementById("chat-history");
            element.scrollTop = element.scrollHeight;
        },
        async getEvents() {
            this.events = await MessagingService.events.index(
                this.selectedConversation.id
            );
            this.$nextTick(function() {
                this.adjustScroll();
            });
        }
    }
};
</script>
